var yt = require('kissfft-js');
window.kiss =require('kissfft-js'); 
console.log(yt);
